import 'sass/app.scss';

import _ from 'lodash';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { FooterLinks } from '../footer/footer-links';
import Footer from '../footer';
import {Link} from 'react-router-dom';

const TopNav = () => {
	return (
        <div className="guttered grid-x align-top align-spaced">
            <div className="columns small-1">
                <a href='/#/main'><div className="logo" style={{transform:'scale(0.6)'}}></div></a>
            </div>
            <div className="columns large">
                <nav className="sign-up-nav">
                    <a href="mailto:info@muzado.com">Contact</a>&nbsp;&nbsp;
                    <a href="/login">Login</a>&nbsp;&nbsp;
                    <Link to="/artist-sign-up">
                        <button style={{fontSize: '1em', margin: '0', width: '8vw', padding: '0.2rem'}} className="add-button">
                            <div style={{margin: '2px'}}>Sign Up</div>
                        </button>
                    </Link>
                </nav>
            </div>
        </div>
	);
};


export class ArtistLanding extends React.Component {
	constructor (props) {
		super(props);
	}

	render() {
			// return <ArtistSignUpForm />;


		return (
			<div>
                <div className="top-nav">
				    <TopNav />
                </div>
				<ToastContainer />
                <div className="guttered">
                    <div id="section-1" className="hero1 segment-1 fade-section margin-bottom-2">
                        <div className="funbox">
                            <p className="wumbo">Music Should Pay You Back</p>
                            <p className="mini">
                            You put in the hours. Late-night sessions. DIY tours. A catalog that means something.<br/>
                            <br/>
                            But streaming? That barely covers lunch.<br/>
                            <br/>
                            Muzado flips the script.<br/>
                            <br/>
                            We built a platform where fans subscribe directly to your music—and you actually get paid.
                            </p>
                        </div>
                    </div>
                    <div id="section-3" className="segment-3 margin-top-2 margin-bottom-2">
                        <div className="hero3 s3-img"/>
                        <div className="contentbox-2">
                        <div className="title lite">Revenue You Can Rely On</div>
                            <div className="paragraph lite">
                                Payments are deposited monthly via Stripe, based on your previous month’s subscriber count.<br/>
                                <br/>
                                There are no royalties to track, no unpredictable payouts—just clean, direct earnings.<br/>
                                <br/>
                                1,000 subscribers = $5,000/year.<br/>
                                Real numbers. Real impact.
                            </div>
                        </div>
                    </div>
                    <div id="section-2" className="segment-2 margin-top-2 margin-bottom-2">
                        <div className="contentbox text-blk">
                            <div className="title">Built by Artists Who’ve Had Enough</div>
                            <div className="paragraph">
                                We’re musicians. We’ve played the empty shows.<br/>
                                We’ve watched labels take the lion’s share.<br/>
                                And we’re tired of watching artists grind while platforms cash in.<br/>
                                <br/>
                                So we built Muzado—something that actually works for artists.<br/>
                                <br/>
                                No gatekeepers. No smoke and mirrors. Just a platform designed to pay you, not play you.
                            </div>
                        </div>
                        <div className="hero2 s2-img fade-section-white"/>
                    </div>
                   
                    <div id="section-4" className="segment-4">
                        <div className="hero4 s4-img"/>
                        <div className="contentbox text-blk">
                            <div className="title">Dedicated Artist Support</div>
                            <div className="paragraph">
                                When you join Muzado, you’re not on your own.<br/>
                                We work closely with our artist community to build tools, explore growth opportunities, and support your long-term success.<br/>
                                We grow when you do.
                            </div>
                        </div>
                    </div>
                    <div id="section-5" className="segment-5">
                        <div className="row expanded">
                            <div className="column large-6" style={{paddingTop: '15vh'}}>
                                <p className="flavor-text">
                                    This isn’t just a platform.<br/>
                                    It’s the shift artists have been asking for.<br/>
                                    No more waiting. No more scraps.<br/>
                                    <br/>
                                    Direct pay. Full control. Real fans.<br/>
                                    <br/>
                                    The platform’s live, and it’s built for you.<br/>
                                    You weren’t asking for too much.<br/>
                                    The industry was offering too little.<br/>
                                    We fixed that.
                                    <br/>
                                    <br/>
                                    Let’s get to work.
                                </p>
                                <div id="app-cta" className="app-cta">
                                    <button className="big-button button">Join the Launch Roster</button>
                                </div>
                            </div>
                            <div className="column large-6 s5-img-group">
                                <div className="support1 s5-img"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wide-footer">
                    <Footer/>
                </div>
            </div>
		);
	}
}

export default ArtistLanding;
